import { useState, useMemo, useCallback } from "react"
import Fuse, { IFuseOptions } from "fuse.js"

import type { Option } from "."

const buildFuseOptions = (
  keys: IFuseOptions<Option>["keys"],
): IFuseOptions<Option> => ({
  keys,
  includeScore: true,
  threshold: 0.4,
  ignoreLocation: true,
})

export function useSearch(
  options: Option[],
  initialQuery = "",
  searchKeys: IFuseOptions<Option>["keys"] = ["label"],
) {
  const [searchQuery, setSearchQuery] = useState<string>(initialQuery)
  const [isSearching, setIsSearching] = useState<boolean>(false)

  const handleSearch = useCallback((text: string) => {
    setIsSearching(true)
    setSearchQuery(text)
  }, [])

  const filteredItems = useMemo(() => {
    const searchTerm = searchQuery.trim().toLowerCase()
    if (searchTerm === "" || !isSearching) return options

    const fuse = new Fuse(options, buildFuseOptions(searchKeys))
    return fuse.search(searchTerm).map(result => result.item)
  }, [searchQuery, options, searchKeys])

  return {
    searchQuery,
    setSearchQuery: handleSearch,
    filteredItems,
    setIsSearching,
  }
}
